import { ListItem } from 'modules/ui/atoms/ListItem'
import useOrder from 'modules/order/state/order/use-order'
import useDrawer from 'modules/drawer/state/use-drawer'
import useConfig from 'modules/config/state/use-config'
import { useTranslation } from 'next-i18next'
import { useFetchDesignationQuery } from 'redux/services/designation'
import useTrackUIElementEvent from 'modules/analytics/hooks/useTrackUIElementEvent'
import mParticleSdk from '@mparticle/web-sdk'

export const ORDER_DESIGNATION_DRAWER_OPENER_DATA_ID = 'order-designation-drawer-opener'

const OrderDesignationDrawerOpener = () => {
  const { t } = useTranslation()

  const config = useConfig()
  const drawer = useDrawer()
  const order = useOrder()
  const trackEvent = useTrackUIElementEvent()

  const { data: designationsResponse } = useFetchDesignationQuery({
    designationId: order.designation.value.designationId,
  })

  const defaultDesignationName = designationsResponse?.name

  const label = t('orderDesignationDrawerOpener.listItem.label', "I'd like to support")

  const handleClick = () => {
    // Track the "Value Selected" event for program designation start
    trackEvent('Value Selected', mParticleSdk.EventType.Other, {
      tracking_id: 'program designation start',
      value: label,
    })

    drawer.open('designation')
  }

  return config.designation.isEnabled ? (
    <ListItem
      icon="designation"
      label={label}
      dataId={ORDER_DESIGNATION_DRAWER_OPENER_DATA_ID}
      onClick={handleClick}
      subtitle={
        order.designation.value.designationName ||
        defaultDesignationName ||
        t('orderDesignationDrawerOpener.listItem.subtitle', "Where it's needed the most")
      }
      isDrawerComplete={!!order.designation.value.designationName}
      color={config.theme['--theme-color__brand-primary'] || ''}
    />
  ) : null
}

export default OrderDesignationDrawerOpener
